import { Pipe, PipeTransform } from '@angular/core';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'sanitizeText'
})
export class SanitizeTextPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) {
      return '';
    }

    return DOMPurify.sanitize(value, {
      USE_PROFILES: { html: false }
    });
  }

}
